module.exports = __webpack_public_path__ + "static/media/pixeled-info-container-white.3bf04867.svg";